export class HighchartsOptions{
    #title = {
        text: "",
        align: "left"
    };
    #series = [];
    #hasScrollbar = false;
    #isFeature = false;

    constructor(title, series, hasScrollbar, isFeature){
        this.#title.text = title;
        this.#series = series;
        this.#hasScrollbar = hasScrollbar;
        this.#isFeature = isFeature;
    }

    createHighchartObject(){
        let newHighchartObject = {
            chart: {
                type: "column"
            },
            title: this.#title,
            yAxis: {
                title: {
                    enabled: false
                }
            },
            plotOptions: {
                column: {
                    depth: 25,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}'
                    }
                }
            },
            series: this.#series
        }

        if(this.#hasScrollbar){
            newHighchartObject.chart.scrollablePlotArea = {
                minWidth: 800,
                scrollPositionX: 1
            }
            newHighchartObject.plotOptions.bar = {
                dataLabels: {
                    enabled: true
                }
            }
            newHighchartObject.plotOptions.series = {
                grouping: false
            }
            newHighchartObject.scrollbar = {
                enabled: true,
                barBackgroundColor: 'gray',
                barBorderRadius: 7,
                barBorderWidth: 0,
                buttonBackgroundColor: 'gray',
                buttonBorderWidth: 0,
                buttonArrowColor: 'white',
                buttonBorderRadius: 7,
                rifleColor: 'white',
                trackBackgroundColor: '#f2f2f2',
                trackBorderWidth: 1,
                trackBorderColor: '#f2f2f2',
            }
            newHighchartObject.events = {
                load: function () {
                    const chart = this;

                    chart.series[0]?.group?.attr({
                        zIndex: 1
                    })
                    console.log('Plot width:', this.plotWidth);
                }
            }
        }

        if(this.#isFeature){
            newHighchartObject.xAxis = {
                categories: this.#series?.labels,
                scrollbar: {
                    enabled: true,
                },
                tickLength: 0
            }

            delete newHighchartObject.series;

            newHighchartObject.series = [
                {name: "Quantidade", data: this.#series?.data}
            ];
        }

        return newHighchartObject;
    }

    takeEmptyHighchartValueOfAxisY(){
        const highchartsLabels = document.getElementsByClassName("highcharts-label");

        for(let i = 0; i < highchartsLabels?.length; i++){
            let elementWhichDataIsDisplayed = highchartsLabels[i]?.getElementsByTagName("text")[0]?.getElementsByTagName("tspan")[0];
            
            if(parseInt(elementWhichDataIsDisplayed?.textContent) === 0){
                console.log(elementWhichDataIsDisplayed?.style)
                elementWhichDataIsDisplayed.style.display = "none";
            }
        }
    }
};